import { gql } from 'graphql-request'
import useLazyQuery from '@/hooks/useLazyQuery'

export const ORDER_HISTORY_SERVICE = gql`
  query sellerOrderHistoryService(
    $period: PeriodInput!
    $pagination: PaginationInput!
    $migration: Boolean
  ) {
    orderHistory(
      pagination: $pagination
      period: $period
      migration: $migration
    ) {
      number
      date
      status
      customer {
        name
      }
      items {
        variantId
        name
        amount
      }
      delivery {
        type
        courier {
          email
        }
      }
      completedAt
      statusHistories {
        date
        status
        userEmail
        reasons
      }
    }
  }
`

export const ORDER_HISTORY_SERVICE_KEY = 'useOrderHistoryService'

export const useOrderHistoryService = () => {
  return useLazyQuery({
    key: ORDER_HISTORY_SERVICE_KEY,
    query: ORDER_HISTORY_SERVICE,
    queryOptions: { gcTime: 0 },
  })
}
